const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* =====================================================================
   THEPUREBEAUTY : jauge livraison offerte + affichage "OFFERT" des cadeaux
   Les cadeaux (Cadeau Mystère, Brosse, Trousse) sont ajoutés par l'app
   "Auto Add to Cart" (propriété _Gifted). Ce script ne fait que l'affichage.
   Montants en centimes : 7000 = 70 €
   ===================================================================== */
(function () {
  var FREE_SHIPPING_THRESHOLD = 7000; // 70 €
  var MYSTERY_VARIANT_ID = 53162724688205; // Cadeau Mystère 🎁 (toujours offert)
  var TXT_PROGRESS = 'Plus que <strong>[amount]</strong> pour profiter de la livraison offerte 🚚';
  var TXT_DONE = '<strong>Bravo !</strong> La livraison est offerte 🎉';
  var TXT_GIFT = 'OFFERT 🎁';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastCart = null;
  var started = false;
  var fetchTimer = null;

  function money(cents) {
    return (cents / 100)
      .toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })
      .replace(',00', '');
  }

  function refreshCart() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCart = cart;
          if (!fixGiftQuantities(cart)) decorate();
        })
        .catch(function () {});
    }, 250);
  }

  /* Un seul exemplaire de chaque cadeau par commande */
  var fixHistory = [];
  function giftType(item) {
    if (item.properties && item.properties._Gifted) return String(item.properties._Gifted).toLowerCase().trim();
    if (item.variant_id === MYSTERY_VARIANT_ID) return 'cadeau mystère';
    return null;
  }

  function fixGiftQuantities(cart) {
    var seen = {};
    var updates = {};
    var needed = false;
    cart.items.forEach(function (item) {
      var type = giftType(item);
      if (!type) return;
      if (!seen[type]) {
        seen[type] = true;
        if (item.quantity !== 1) { updates[item.key] = 1; needed = true; }
      } else {
        updates[item.key] = 0;
        needed = true;
      }
    });
    if (!needed) return false;

    // anti-boucle : 4 corrections max en 20 s
    var now = Date.now();
    fixHistory = fixHistory.filter(function (t) { return now - t < 20000; });
    if (fixHistory.length >= 4) return false;
    fixHistory.push(now);

    var body = { updates: updates };
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    if (drawer && !onCartPage) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || !res.items) { decorate(); return; }
        lastCart = res;
        if (onCartPage) { window.location.reload(); return; }
        if (drawer && res.sections && drawer.getSectionsToRender) {
          drawer.getSectionsToRender().forEach(function (s) {
            var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
            if (!el || !res.sections[s.id]) return;
            el.innerHTML = drawer.getSectionInnerHTML(res.sections[s.id], s.selector);
          });
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        decorate();
      })
      .catch(function () { decorate(); });
    return true;
  }

  function isGift(item) {
    return item.variant_id === MYSTERY_VARIANT_ID || !!(item.properties && item.properties._Gifted);
  }

  function giftLabel(item) {
    var v = item.properties && item.properties._Gifted;
    if (!v) return 'Offert avec ta commande';
    v = String(v);
    return v.charAt(0).toUpperCase() + v.slice(1).toLowerCase();
  }

  function barHTML(subtotal) {
    var pct = Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100));
    var text = subtotal >= FREE_SHIPPING_THRESHOLD
      ? TXT_DONE
      : TXT_PROGRESS.replace('[amount]', money(FREE_SHIPPING_THRESHOLD - subtotal));
    return '<p class="mg-ship__text">' + text + '</p>' +
      '<div class="mg-ship__track"><div class="mg-ship__fill' + (pct >= 100 ? ' mg-ship__fill--done' : '') +
      '" style="width:' + pct + '%"></div></div>';
  }

  function placeBar(container, insert) {
    if (!container) return;
    var bar = container.querySelector(':scope > .mg-ship');
    if (!lastCart || lastCart.item_count === 0) {
      if (bar) bar.remove();
      return;
    }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'mg-ship';
      insert(bar);
    }
    var html = barHTML(lastCart.items_subtotal_price);
    if (bar._mgHtml !== html) {
      bar.innerHTML = html;
      bar._mgHtml = html;
    }
  }

  function markGiftRow(row, item) {
    if (!row || row._mgKey === item.key) return;
    row._mgKey = item.key;
    row.classList.add('mg-gift-row');
    row
      .querySelectorAll('.price, .cart-item__details > .product-option, .cart-item__final-price')
      .forEach(function (el) { el.textContent = TXT_GIFT; });
    var details = row.querySelector('.cart-item__details');
    if (details && !details.querySelector('.mg-gift-label')) {
      var label = document.createElement('p');
      label.className = 'mg-gift-label';
      label.textContent = '🎁 ' + giftLabel(item);
      var title = details.querySelector('.cart-item__title') || details.querySelector('.cart-item__name');
      if (title) title.insertAdjacentElement('afterend', label);
      else details.appendChild(label);
    }
  }

  function decorate() {
    if (!lastCart) return;

    var inner = document.querySelector('cart-drawer .drawer__inner');
    placeBar(inner, function (bar) {
      var header = inner.querySelector(':scope > .drawer__header');
      if (header) header.insertAdjacentElement('afterend', bar);
      else inner.prepend(bar);
    });

    var main = document.getElementById('main-cart-items');
    placeBar(main, function (bar) { main.prepend(bar); });

    var notif = document.querySelector('#cart-notification .cart-notification__links');
    placeBar(notif, function (bar) { notif.prepend(bar); });

    lastCart.items.forEach(function (item, i) {
      if (!isGift(item)) return;
      var n = i + 1;
      markGiftRow(document.getElementById('CartDrawer-Item-' + n), item);
      markGiftRow(document.getElementById('CartItem-' + n), item);
    });
  }

  function ownMutation(records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (!(t.closest && (t.closest('.mg-ship') || t.closest('.mg-gift-label')))) {
        var nodes = Array.prototype.slice.call(records[i].addedNodes)
          .concat(Array.prototype.slice.call(records[i].removedNodes));
        var mine = nodes.length > 0 && nodes.every(function (nd) {
          return nd.nodeType === 1 && nd.classList &&
            (nd.classList.contains('mg-ship') || nd.classList.contains('mg-gift-label'));
        });
        if (!mine) return false;
      }
    }
    return true;
  }

  function injectStyles() {
    var css =
      '.mg-ship{padding:1.2rem 0 1.4rem;margin-bottom:.4rem;border-bottom:.1rem solid rgba(var(--color-foreground),.08)}' +
      '#main-cart-items>.mg-ship{max-width:60rem;margin:0 auto 2rem;border:0}' +
      '.cart-notification__links>.mg-ship{border:0;padding-top:0}' +
      '.mg-ship__text{margin:0 0 .8rem;font-size:1.4rem;line-height:1.4;text-align:center;color:rgb(var(--color-foreground))}' +
      '.mg-ship__track{height:.8rem;border-radius:1rem;background:rgba(var(--color-foreground),.1);overflow:hidden}' +
      '.mg-ship__fill{height:100%;border-radius:1rem;background:rgb(var(--color-button));transition:width .4s ease}' +
      '.mg-ship__fill--done{background:#2e9e5b}' +
      '.mg-gift-row quantity-input,.mg-gift-row cart-remove-button,.mg-gift-row .cart-item__old-price{display:none!important}' +
      '.mg-gift-row .price,.mg-gift-row .cart-item__details>.product-option,.mg-gift-row .cart-item__final-price{color:#c2185b;font-weight:600}' +
      '.mg-gift-label{margin:.2rem 0 .4rem;font-size:1.2rem;font-weight:600;color:#c2185b}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function init() {
    if (started) return;
    started = true;
    injectStyles();

    var CART_ZONES = 'cart-drawer, #main-cart-items, #cart-notification, #cart-icon-bubble';
    new MutationObserver(function (records) {
      var inCart = records.some(function (r) {
        return r.target.closest && r.target.closest(CART_ZONES);
      });
      if (!inCart || ownMutation(records)) return;
      refreshCart();
    }).observe(document.body, { childList: true, subtree: true });

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    }
    refreshCart();
  }

  if (document.readyState === 'complete') init();
  else {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  }
})();
